export default function() {
  /* 表格列头（用 min-width 让整行铺满，不再出现右侧大片空白） */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "店铺ID", prop: "store_id", minWidth: 100 },
    { label: "店铺名称", prop: "store_name", minWidth: 160 },
    { label: "会员卡号", prop: "vip_number", minWidth: 180 },
    { label: "会员手机号", prop: "user_phone", minWidth: 150 },
    { label: "用户ID", prop: "user_id", slots: "user_id", minWidth: 120 },
    { label: "核销人ID", prop: "cancel_id", minWidth: 100 },
    { label: "核销人手机号", prop: "cancel_phone", minWidth: 130 },
    { label: "金额", prop: "amount", slots: "amount", minWidth: 90 },
    { label: "余额", prop: "money", minWidth: 100 },
    { label: "交易描述", prop: "message", minWidth: 180 },
    {
      label: "交易时间",
      prop: "create_time",
      minWidth: 180,
    },
    {
      label: "操作",
      prop: "operation",
      minWidth: 100,
      slots: "operation",
    },
  ];
}
